import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { WebPageUrlModal } from "./WebPageUrlModal";
import ducky from "../../assets/models/DuckyMesh.glb";

export function WebPageUrlModalContainer({ scene, onClose }) {
  const onSubmit = useCallback(
    ({ src, iframe_display }) => {
      var url = new URL(src);
      url.searchParams.set("iframe_display", iframe_display);
      scene.emit("add_media", url.toString() || ducky);
      onClose();
    },
    [scene, onClose]
  );

  return <WebPageUrlModal onSubmit={onSubmit} onClose={onClose} />;
}

WebPageUrlModalContainer.propTypes = {
  scene: PropTypes.object.isRequired,
  onClose: PropTypes.func
};
